import { render, staticRenderFns } from "./ChatChallengesComponent.vue?vue&type=template&id=449f471b&scoped=true&"
import script from "./ChatChallengesComponent.vue?vue&type=script&lang=ts&"
export * from "./ChatChallengesComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChatChallengesComponent.vue?vue&type=style&index=0&id=449f471b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449f471b",
  null
  
)

export default component.exports